import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadersModule } from '@shared/core/components/loaders';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForLoadingComponent } from './modal-for-loading.shared.component';

@NgModule({
    declarations: [
        ModalForLoadingComponent,
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        LoadersModule,
    ],
    exports: [
        ModalForLoadingComponent,
    ],
    providers: [],
})
export class ModalForLoadingModule { }
